module.exports = __webpack_public_path__ + "media/images/athletes/1459-3c8a594c319c6328ae633b55e6b9b91b.png";